
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Luxurypginhinjewadinearblueridge() {



    const cardData =
    {
        keyword: 'Luxury PG in Hinjewadi Near Blue Ridge and Megapolis ',
        heading: 'Shree Swami Samarth PG: Luxury PG in Hinjewadi Near Blue Ridge and Megapolis',
        headingDescription: 'Shree Swami Samarth PG offers premium and well-furnished luxury PG in Hinjewadi near Blue Ridge and Megapolis, designed to provide a modern, safe, and hassle-free living experience for IT professionals and students. Located in one of the most sought-after residential and corporate hubs of Pune, our PG ensures easy access to leading tech parks, educational institutes, and lifestyle amenities. The rooms are elegantly furnished with spacious layouts, comfortable bedding, study/work areas, and stylish interiors, making them ideal for both comfort and productivity. Residents enjoy world-class facilities including air-conditioning, high-speed WiFi, 24x7 water supply, CCTV security, biometric entry, and hygienic home-cooked meals. With professional housekeeping, disciplined management, and a peaceful environment, Shree Swami Samarth PG near Blue Ridge and Megapolis stands out as the perfect choice for those seeking a premium yet affordable stay in Hinjewadi.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Elegant & Fully Furnished Rooms",
    "description": "Luxury PGs near Blue Ridge and Megapolis offer elegantly furnished rooms with premium beds, ergonomic study desks, stylish wardrobes, and plush seating. Many feature air-conditioning and upscale interiors, creating a refined living ambiance. Spacious layouts with large windows promote natural light and ventilation, making these rooms a serene retreat after long workdays. Designed with comfort, sophistication, and privacy in mind, these accommodations set a new standard for PG living in Hinjewadi."
  },
  {
    "title": "Gourmet Meals & Clean Kitchens",
    "description": "These premium PGs elevate daily living with gourmet-style meals prepared in hygienic, fully equipped kitchens. Residents enjoy balanced breakfast, lunch, and dinner options, often with continental or regional cuisine choices. Attention to dietary preferences, including vegetarian and special meals, ensures a personalized dining experience. This saves time and promotes wellness while delivering a taste of home in a luxurious setting."
  },
  {
    "title": "High-Speed Wi-Fi & Business-Ready Spaces",
    "description": "Designed with professionals in mind, these PGs deliver high-speed, uninterrupted Wi-Fi throughout the property. Dedicated co-working areas or study lounges equipped with charging docks and ample lighting offer an office-like atmosphere. Power backup systems reinforce reliability, enabling seamless remote work or study sessions. Whether attending virtual meetings or completing projects, residents benefit from a digital-first, productivity-focused environment."
  },
  {
    "title": "Top-Tier Safety & Women-Friendly Features",
    "description": "Safety is a priority in PGs around Blue Ridge and Megapolis. Expect biometric or smart access, strategic CCTV coverage, and professional security staff. Many properties include female wardens or dedicated staffing for enhanced comfort. Located within gated communities or secure complexes, these PGs ensure peace of mind for women professionals working late, along with their families."
  },
  {
    "title": "Strategic Location Amidst Growth Corridors",
    "description": "Positioned between the thriving hubs of Blue Ridge and Megapolis, these PGs offer premium access to commercial zones, IT offices, retail centers, and wellness facilities. Proximity to Blue Ridge Township, Megapolis splendor, and Hinjewadi Phase 3 enhances connectivity and lifestyle. Daily commute is effortless, while nearby cafés, supermarkets, and gyms elevate convenience and leisure."
  },
  {
    "title": "Daily Housekeeping & Laundry Support",
    "description": "Maintaining a clean, fresh environment is a signature of these luxury PGs. Daily housekeeping ensures pristine rooms, bathrooms, and common areas, while professional laundry services or on-site washing facilities save time for busy residents. High maintenance standards elevate hygiene, convenience, and overall comfort."
  },
  {
    "title": "Recreation & Lifestyle Amenities",
    "description": "Luxury PGs near these locales go beyond basic necessities. Many include lounges with entertainment systems, indoor game zones, mini libraries, and fitness corners. Some upscale options may offer features like a café, landscaped common area, or activity space. These amenities foster relaxation, socializing, and work-life balance in a sophisticated setting."
  },
  {
    "title": "Transparent Premium Pricing",
    "description": "These luxury PGs adopt clear pricing models that typically include meals, Wi-Fi, housekeeping, and security in one package. Rates usually range from ₹12,000–₹20,000/month for shared luxury rooms, with premium singles or suites commanding higher costs. While more exclusive, these PGs deliver unmatched comfort, convenience, and lifestyle, justifying the investment for discerning residents."
  }
],


"services": [
  {
    "name": "Luxury PG in Hinjewadi Near Blue Ridge",
    "description": "Shree Swami Samarth PG offers top-tier luxury PG accommodation near Blue Ridge Township in Hinjewadi. With spacious AC rooms, premium furnishings, daily housekeeping, high-speed Wi-Fi, and chef-prepared meals, our PG is ideal for professionals who prefer upscale living close to IT hubs."
  },
  {
    "name": "Premium PG Near Megapolis Hinjewadi",
    "description": "Located just minutes from Megapolis, our premium PG is perfect for tech employees working in and around Hinjewadi. Shree Swami Samarth PG provides executive-class amenities, including smart interiors, attached washrooms, home-style food, and round-the-clock support in a peaceful, well-connected neighborhood."
  },
  {
    "name": "Executive PG Near Blue Ridge Hinjewadi",
    "description": "Tailored for senior executives and corporate travelers, Shree Swami Samarth PG near Blue Ridge in Hinjewadi delivers a refined stay with modern interiors, private rooms, reliable services, and full privacy. It's your smart alternative to hotels or serviced apartments—ideal for long-term stays."
  },
  {
    "name": "High-End PG in Hinjewadi for Working Professionals",
    "description": "Upgrade your lifestyle with our high-end PG for working professionals in Hinjewadi. Shree Swami Samarth PG features designer rooms, AC, Wi-Fi, curated meals, and quiet surroundings—offering a complete premium living experience near top tech companies like Infosys, TCS, and Wipro."
  },
  {
    "name": "Furnished Luxury PG Near Blue Ridge & Megapolis",
    "description": "Experience the comfort of a fully furnished luxury PG near both Blue Ridge and Megapolis. Shree Swami Samarth PG includes cozy beds, wardrobes, study areas, attached baths, and premium appliances—making it a ready-to-move-in home for IT professionals who value style and ease."
  },
  {
    "name": "Single Room Luxury PG in Hinjewadi",
    "description": "Prefer privacy? Our single room luxury PG in Hinjewadi offers exclusive living with all the perks of premium housing—private AC rooms, personal washrooms, uninterrupted Wi-Fi, and freshly prepared meals—ideal for managers, freelancers, or introverted professionals."
  },
  {
    "name": "AC Luxury PG Near Tech Parks Hinjewadi",
    "description": "Stay cool and comfortable year-round at our AC luxury PG near Hinjewadi's leading tech parks. Shree Swami Samarth PG offers centrally located, well-maintained accommodations equipped with cooling, cleaning, food, and Wi-Fi—just steps from Blue Ridge, Megapolis, and top office campuses."
  },
  {
    "name": "Best Luxury PG Near Infosys & Cognizant Hinjewadi",
    "description": "Live in comfort just minutes away from Infosys and Cognizant campuses. Shree Swami Samarth PG offers the best luxury PG in Hinjewadi with AC rooms, attached washrooms, daily meals, and high-end finishes—tailored for employees who demand quality and reliability."
  }
],
"tableData": [
  ["Luxury PG in Hinjewadi Near Blue Ridge", "Premium PG Near Megapolis Hinjewadi"],
  ["Executive PG Near Blue Ridge Hinjewadi", "High-End PG in Hinjewadi for Working Professionals"],
  ["Furnished Luxury PG Near Blue Ridge & Megapolis", "Single Room Luxury PG in Hinjewadi"],
  ["AC Luxury PG Near Tech Parks Hinjewadi", "Best Luxury PG Near Infosys & Cognizant Hinjewadi"]
],




"whychoose": [
    {
        "WhyChooseheading": "Luxury PG Living Near Blue Ridge and Megapolis",
        "WhyChoosedescription": "Shree Swami Samarth PG offers a high-end, fully furnished luxury PG experience near Blue Ridge and Megapolis in Hinjewadi Phase 1 & 3. Perfect for working professionals and corporate guests, our PG provides upscale amenities, daily housekeeping, and a peaceful atmosphere just minutes from top IT campuses."
    },
    {
        "WhyChooseheading": "Prime Location with Seamless Access to Tech Parks",
        "WhyChoosedescription": "Our PG is located strategically near Blue Ridge Township and Megapolis, making it ideal for employees of Cognizant, Infosys, TCS, and Tech Mahindra. Reach your office in under 10 minutes via bike, shared cab, or even on foot—saving time and reducing daily stress."
    },
    {
        "WhyChooseheading": "Designer Rooms with Premium Furnishings",
        "WhyChoosedescription": "Each room is styled with luxury in mind—modern decor, soft lighting, plush bedding, work desks, personal wardrobes, and air-conditioning. Whether you choose a single or twin-sharing option, expect comfort that feels like a hotel but with the warmth of home."
    },
    {
        "WhyChooseheading": "Gourmet-Style Meals with Weekly Specials",
        "WhyChoosedescription": "Enjoy three delicious and hygienic meals a day, including breakfast, lunch, and dinner. Our in-house chefs prepare meals using fresh ingredients with rotating menus, weekend specials, and options to suit both vegetarian and non-vegetarian preferences."
    },
    {
        "WhyChooseheading": "Smart Amenities for a Modern Lifestyle",
        "WhyChoosedescription": "From high-speed Wi-Fi and power backup to smart TVs in the lounge, laundry machines, and daily housekeeping, our PG is built for professionals who expect more. Enjoy common lounges, co-living spaces, and quiet zones perfect for both work and relaxation."
    },
    {
        "WhyChooseheading": "Safe and Gated PG for Peace of Mind",
        "WhyChoosedescription": "Security is non-negotiable—our PG offers biometric access, 24/7 CCTV coverage, and gated premises with female-friendly policies. Ideal for working women and corporate guests who prioritize safety in a luxury setting."
    },
    {
        "WhyChooseheading": "Flexible Rent Plans and Corporate Tie-Ups",
        "WhyChoosedescription": "We offer flexible rental packages, including options for short stays, long-term bookings, and corporate tie-ups. All-inclusive pricing covers food, stay, Wi-Fi, electricity, and services—no brokerage or hidden costs."
    },
    {
        "WhyChooseheading": "Tranquil, Professional Atmosphere Near Nature",
        "WhyChoosedescription": "Located near the green surroundings of Blue Ridge and Megapolis, our PG provides a peaceful environment away from city chaos—ideal for professionals who want to recharge after a long day’s work in comfort and serenity."
    }
]






















    }
    
const faqData = [
    {
        question: "How can I book a luxury PG in Hinjewadi near Blue Ridge and Megapolis?",
        answer: "To book a luxury PG near Blue Ridge and Megapolis, simply call us at +91 9594917913. We also support online booking and virtual tours."
    },
    {
        question: "What makes your PG a luxury PG near Blue Ridge and Megapolis?",
        answer: "Our PG offers fully furnished A/C rooms, premium interiors, smart TVs, Wi-Fi, modern bathrooms, hygienic meals, laundry, housekeeping, and lounge/common areas."
    },
    {
        question: "How close is your PG to Blue Ridge and Megapolis Townships?",
        answer: "Our property is within 5–10 minutes of both Blue Ridge and Megapolis, making it ideal for residents working or studying in those areas."
    },
    {
        question: "Do you offer single occupancy in your luxury PG in Hinjewadi?",
        answer: "Yes, we provide single, double, and triple occupancy with premium furnishings and optional air conditioning."
    },
    {
        question: "Is food included in the luxury PG rent?",
        answer: "Yes, we provide freshly prepared, vegetarian meals (breakfast, lunch, and dinner) as part of the rent."
    },
    {
        question: "Is your PG suitable for both students and working professionals near Blue Ridge and Megapolis?",
        answer: "Absolutely. We welcome IT professionals, interns, and students seeking a premium, peaceful, and safe living experience."
    },
    {
        question: "What safety features are available in your luxury PG?",
        answer: "We offer 24/7 CCTV surveillance, biometric access, secure entry points, and in-house staff for maximum safety and convenience."
    },
    {
        question: "Do you have power backup and high-speed Wi-Fi?",
        answer: "Yes, we provide uninterrupted power backup and high-speed Wi-Fi suitable for remote work and streaming."
    },
    {
        question: "What is the monthly rent for a luxury PG near Blue Ridge and Megapolis?",
        answer: "Rent depends on occupancy type and amenities. Please contact us directly for a customized quote and current availability."
    },
    {
        question: "How do I contact Shree Swami Samarth PG to book a luxury PG in Hinjewadi?",
        answer: "Call us at +91 9594917913 for bookings, visits, or to know more about our luxury PG services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Aditya Naik',
        designation: 'Senior Developer, Cognizant Blue Ridge',
        rating: [1, 1, 1, 1, 1],
        text: '“This is one of the finest PGs near Blue Ridge. Everything from the interiors to food and Wi-Fi is top-notch. Truly a luxury experience.”',
    },
    {
        name: 'Ms. Radhika Gawde',
        designation: 'UI/UX Designer, Megapolis Tech Park',
        rating: [1, 1, 1, 1, 1],
        text: '“I loved staying here! It’s just minutes from my office at Megapolis and feels like a serviced apartment. Great food and well-maintained rooms.”',
    },
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury PG in Hinjewadi Near Blue Ridge and Megapolis",
  "image": "https://swamisamarthpg.com/assets/images/luxury-pg-hinjewadi-blue-ridge-megapolis.jpg", // Replace with actual image URL
  "description": "Experience furnished luxury PG accommodations near Blue Ridge and Megapolis in Hinjewadi. Ideal for working professionals seeking AC rooms, single rooms, and premium amenities close to Infosys and Cognizant.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.95",
    "ratingCount": "1750"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11500",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/luxury-pg-hinjewadi-blue-ridge-megapolis"  // Replace with actual page URL if different
  }
};








    return (
        <div>

<Helmet>
  <title>Luxury PG in Hinjewadi Near Blue Ridge and Megapolis | Premium PG for Professionals</title>
  <meta 
    name="description" 
    content="Furnished luxury PG near Blue Ridge and Megapolis Hinjewadi with AC and single rooms. Perfect for working professionals near Infosys, Cognizant, and major tech parks." 
  />
  <meta 
    name="keywords" 
    content="Luxury PG in Hinjewadi Near Blue Ridge, Premium PG Near Megapolis Hinjewadi, Executive PG Near Blue Ridge Hinjewadi, High-End PG in Hinjewadi for Working Professionals, Furnished Luxury PG Near Blue Ridge & Megapolis, Single Room Luxury PG in Hinjewadi, AC Luxury PG Near Tech Parks Hinjewadi, Best Luxury PG Near Infosys & Cognizant Hinjewadi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxurypginhinjewadinearblueridge;